//dependencies
import { useQuery } from "@tanstack/react-query";

//service contracts
import { GetEmailTokenResponse } from "@performyard/service-contracts";

// queries
import { emailTokensQuery } from "../../queries";

export const useEmailTokens = (userId: string) => {
	return useQuery<GetEmailTokenResponse>(emailTokensQuery(userId));
};
